module.exports = __webpack_public_path__ + "static/media/help-icon.e32a5f07.svg";